import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { environment } from '../environments/environment.prod';
import { Severity } from '@sentry/types';
// import { environment } from '../environments/environment';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  constructor() {
    Sentry.init({
      dsn: environment.dsn_sentry,
    });
  }

  handleError(error: any): void {
    // const user = JSON.parse(localStorage.getItem('User')) || {};
    console.error(error);
    // Sentry.captureMessage(`Error - Tenant: ${user.tenant_id}|User: ${user._id} `, Severity.Error);
    // Sentry.captureException(error.originalError || error);
    // throw error;
  }
}



// WEBPACK FOOTER //
// ./src/app/sentry.ts